/**
 * Bank Statements Routes
 *
 * These routes are children of bank-accounts/:id and inherit the :id param
 */

export default [
    {
        path: 'bank-statements',
        component: () =>
            import('@/pages/[organisation]/banking/bank-statements/bank-statements.vue'),
        name: 'banking.bank-transactions.bank-statements',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.money-in',
        },
    },
];
